var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trac\xE9_120") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NEWS_DIAG-1",
    transform: "translate(-99.000000, -1242.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRODUIT",
    transform: "translate(56.000000, 969.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "raindrops",
    transform: "translate(25.300000, 255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trace\\u0301-120",
    transform: "translate(18.700000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8204056,0.433001183 C20.2161376,1.40940614 16.7915157,2.95678101 13.6766556,5.01633452 C6.83063223,9.38618994 1.94671134,16.2413792 0.0526972318,24.1392512 C0.0185735613,24.2625077 0.0543956077,24.3945629 0.146128685,24.4836788 C0.237861761,24.5727947 0.370898162,24.6047805 0.493115679,24.5671045 C0.615333195,24.5294284 0.707269734,24.4280901 0.732905565,24.3027928 C4.9224889,6.85487618 21.3349889,1.82570952 23.6974889,1.18820952 C23.9172806,1.85383452 24.2881139,3.93925118 22.2266556,7.70800118 L15.0787389,9.00175118 C14.9027049,9.03526973 14.7804222,9.19633327 14.7954368,9.37489983 C14.8104514,9.5534664 14.9579128,9.69184875 15.1370722,9.69550118 L20.7339472,9.75175118 L18.4839472,13.1527928 L11.0495722,13.0298762 C10.8700778,13.0305535 10.7189483,13.1642964 10.6964472,13.3423762 C10.6766577,13.5222494 10.7972461,13.6875504 10.9745722,13.7236262 L17.1339472,14.9736262 C15.9881139,16.0361262 12.8891556,18.6194595 9.5787389,18.7621678 C5.30269723,18.9475845 3.69853057,18.8882095 3.68290557,18.8882095 C3.49161491,18.8850388 3.33157301,19.0326992 3.3193639,19.2236262 C3.31173076,19.4165891 3.46182819,19.5792724 3.65478057,19.5871678 C3.7193639,19.5871678 5.29540557,19.6486262 9.60894723,19.4611262 C14.0495722,19.2684178 17.9422806,15.1757095 18.1047806,15.0017512 C18.1915016,14.909229 18.2213938,14.7770362 18.1829176,14.6562038 C18.1444414,14.5353713 18.0436162,14.4448023 17.9193639,14.4194595 L14.8193639,13.7882095 L18.6631139,13.8517512 C18.7818789,13.8500573 18.8926457,13.7915755 18.9610306,13.6944595 L21.6693639,9.59758452 C21.7399156,9.49063404 21.7463901,9.35368127 21.6862426,9.24055198 C21.6260952,9.1274227 21.5089401,9.05620002 21.3808222,9.05487618 L18.8266556,9.02883452 L22.5099889,8.36216785 C22.6131954,8.34362299 22.70265,8.27978149 22.7537389,8.18820952 C25.5912389,3.09341785 24.2579056,0.688209516 24.1995722,0.593417849 C24.1224041,0.461382841 23.9684464,0.394738152 23.8193639,0.428834516 L23.8204056,0.433001183 Z",
    id: "Trac\\xE9_120"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlume);
export default __webpack_public_path__ + "static/media/Plume.b99c1264c79cc1404c32181f32a7b31a.svg";
export { ForwardRef as ReactComponent };